<template>
  <v-card flat class="mt-1 grey lighten-4">
    <!-- Search reulsts filter -->
    <v-slide-y-transition>
      <v-card-title v-if="showGridFilter">
        <v-layout row wrap>
          <v-flex :sm12="ruleQuickView" :sm4="!ruleQuickView">
            <v-text-field append-icon="filter_list" :label="messages.label.RULES_FILTER" single-line hide-details
              clearable v-model="search" @input="value => filterRulesList(value)"></v-text-field>
          </v-flex>
          <v-flex sm8 class="text-xs-right" v-show="!ruleQuickView">
            <div class="mr-2 mt-3">
              <v-icon color="accent darken-2" class="pr-2" small>info</v-icon>
              <span v-html="messages.info.RULE_DETAILS"></span>
            </div>
          </v-flex>
        </v-layout>
      </v-card-title>
    </v-slide-y-transition>
    <!-- Search Results -->
    <v-card-text class="py-1">
      <v-data-table :headers="headers" :items="filteredRulesList" :pagination.sync="pagination"
        :total-items="totalItems" :loading="rulesLoading" :rows-per-page-items="rowsPerPagesArray">
        <!-- Items -->
        <template slot="items" slot-scope="props">
          <tr :active="!!selectedRule && selectedRule.id == props.item.id" @click="showQuickView(props.item)"
            class="pointer">
            <td class="text-xs-left">{{ props.item.title }}</td>
            <td class="text-xs-left" v-if="!ruleQuickView">{{ props.item.type ? props.item.type.toString() : "n/a" }}
            </td>
            <td class="text-xs-left" v-if="!ruleQuickView">{{ props.item._enabled }}</td>
            <td class="text-xs-center" v-if="displayActionsCount()">{{ getRuleActionsCount(props.item.actions) }}</td>
            <td class="text-xs-center" v-if="displayConditionsCount()">{{ getRuleConditionsCount(props.item.conditions)
            }}</td>
            <td class="text-xs-center" v-if="displayRulesCount()">{{ getRulesCount(props.item.items) }}</td>
            <td class="text-xs-center" v-if="displayRuleSetsCount()">{{ getRuleSetsCount(props.item.items) }}</td>
            <td class="text-xs-left" v-if="!ruleQuickView">{{ props.item._added }}</td>
            <td class="text-xs-left" v-if="!ruleQuickView">{{ props.item._updated }}</td>
            <td @click.stop="stopProp" v-if="!ruleQuickView">
              <v-menu offset-y left :disabled="rulesLoading">
                <v-btn icon slot="activator">
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>
                  <!-- <v-list-tile @click="showCopyRuleModal(props.item)">
                    <v-list-tile-title>{{ getCopyLabelInfo() }}</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click="showOverrideRuleModal(props.item)">
                    <v-list-tile-title>{{ getOverrideLabelInfo() }}</v-list-tile-title>
                  </v-list-tile> -->
                  <v-list-tile @click="showTestRuleModal(props.item)">
                    <v-list-tile-title>{{ messages.label.TEST }}</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click="goToEditView(props.item)">
                    <v-list-tile-title>{{ messages.label.EDIT }}</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click="showDeleteDialog(props.item)" class="error--text">
                    <v-list-tile-title>{{ messages.label.DELETE }}</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </td>
          </tr>
        </template>
        <!-- No Data -->
        <template slot="no-data">
          <v-alert :value="true" color="info" class="black--text" icon="info">
            <span v-if="!initiatedSearch">{{ messages.info.SELECT_SEARCH_CRITERIA }}</span>
            <span v-else>{{ messages.info.NO_SEARCH_RESULTS }}</span>
          </v-alert>
        </template>
        <!-- No Results -->
        <template slot="no-results">
          <v-alert :value="true" color="info" class="black--text" icon="info">{{ messages.info.NO_FILTER_RESULTS }}
          </v-alert>
        </template>
      </v-data-table>
      <!-- Dialogs -->
      <!-- Delete Rule/RuleSet/RuleCollection -->
      <v-dialog v-model="deleteDialog" width="500">
        <v-card>
          <v-card-title class="subheading ttu">{{ messages.label.DELETE }} {{ getRuleCategoryTitle() }}</v-card-title>
          <v-card-text>
            <!-- Error Alert -->
            <v-flex xs12 v-if="deleteErrorAlert">
              <v-alert v-model="deleteErrorAlert" type="error">{{ deleteErrorMessage }}</v-alert>
            </v-flex>
            <v-flex xs12 v-else>
              <p>
                {{ messages.info.DELETE_RULE_1 }}
                <b>{{ selectedRuleToDelete.title }}</b> ?
              </p>
              <p v-html="messages.info.DELETE_RULE_2"></p>
            </v-flex>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <template v-if="deleteErrorAlert">
              <v-btn color="secondary lighten-1 white--text" @click="cancelDelete">Close</v-btn>
            </template>
            <template v-else>
              <v-btn color="grey lighten-1 white--text" @click="cancelDelete">{{ messages.label.CANCEL }}</v-btn>
              <v-btn color="error" :disabled="deletingRule" :loading="deletingRule" @click="deleteRuleItem()">{{
              messages.label.YES
              }}</v-btn>
            </template>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Rule Test Dialog -->
      <XVATRuleTest v-model="ruleTestDialog" :rule-obj="ruleObjectToTest" :rule-category="rulesQueryObject.category" />
      <!-- Rule Copy Dialog -->
      <XVATRuleCopy v-model="ruleCopyDialog" :rule-obj="ruleObjectToCopy" />
      <!-- Rule Override Dialog -->
      <XVATRuleOverride v-model="ruleOverrideDialog" :rule-obj="ruleObjectToOverride" />
      <!-- Snackbar -->
      <v-flex xs12>
        <v-snackbar :bottom="true" :timeout="snackbar.timeout" :color="snackbar.color" v-model="snackbar.show">
          {{ snackbar.message }}
          <v-btn flat color="primary" @click.native="snackbar.show = false">Ok</v-btn>
        </v-snackbar>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState, mapMutations } from "vuex"
import XVATRulesService from "@/XVAT/XVATRulesService"
import * as xvatRulesDataService from "@/XVAT/XVATDataService"
import XVATRuleTest from "@/XVAT/XVATRuleTest"
import AppService from "@/AppService"
import messages from "@/XVAT/messages.json"
import { SET_RULE_QUICK_VIEW } from "@/store/constants/mutation-types"
import XVATRuleCopy from "@/XVAT/XVATRuleCopy"
import XVATRuleOverride from "@/XVAT/XVATRuleOverride"
import {
  RULE_TYPE_TRANSFORMATION,
  RULE_CAT_RULE,
  RULE_CAT_RULE_SET,
  RULE_CAT_RULE_COLLECTION
} from "./constants"

function initialData() {
  return {
    search: "",
    selectedRule: {},
    rulesLoading: false,
    initiatedSearch: false,
    ruleObjectToTest: {},
    ruleTestDialog: false,
    ruleCopyDialog: false,
    ruleObjectToCopy: {},
    ruleObjectToOverride: {},
    ruleOverrideDialog: false,
    pagination: {
      sortBy: "title",
      page: 1,
      rowsPerPage: 25,
      descending: false
    },
    snackbar: {
      show: false,
      timeout: 3000,
      color: "error",
      message: ""
    },
    totalItems: 0,
    rowsPerPagesArray: [25, 50, 75, 100],
    rulesQueryObject: {
      category: "rule"
    },
    filteredRulesList: [],
    rulesList: [],
    deleteDialog: false,
    deletingRule: false, // Used for Rule / Rule Set / Rule collection
    selectedRuleToDelete: {},
    deleteErrorAlert: false,
    deleteErrorMessage: ""
  }
}
export default {
  name: "XVATRulesSearchResult",
  components: {
    XVATRuleTest,
    XVATRuleCopy,
    XVATRuleOverride
  },
  data: function () {
    return initialData()
  },
  computed: {
    ...mapState("xvat", [
      "ruleQuickView"
    ]),
    showGridFilter() {
      return this.rulesLoading || this.rulesList.length > 0
    },
    /**
    * headers  - Construct array of objects to show table headers
    * @return {array}
    */
    headers() {
      return this.getTableHeaders()
    }
  },
  watch: {
    /**
     * Watch handler for pagination object
     */
    pagination: {
      handler(newVal, oldVal) {
        if (this.initiatedSearch && oldVal !== newVal) {
          this.searchRules()
        }
      },
      deep: true
    }
  },
  methods: {
    ...mapMutations("xvat", [
      SET_RULE_QUICK_VIEW
    ]),
    /**
     * reset
     */
    reset() {
      Object.assign(this.$data, initialData())
      this.SET_RULE_QUICK_VIEW(false)
    },
    /**
     * getTableHeaders - Construct table headers to be displayed
     * @returns {array}
     */
    getTableHeaders() {
      let headerToDisplay = []
      let commonHeaders = [{
        text: messages.label.TH_TITLE,
        sortable: true,
        align: "left",
        value: "title"
      },
      {
        text: messages.label.TH_TYPE,
        sortable: false,
        align: "left",
        value: "type"
      },
      {
        text: messages.label.TH_ENABLED,
        sortable: false,
        align: "left",
        value: "disabled"
      }]

      let dateAndActionHeaders = [{
        text: messages.label.TH_ADDED,
        sortable: true,
        align: "left",
        value: "added"
      }, {
        text: messages.label.TH_UPDATED,
        sortable: true,
        align: "left",
        value: "updated"
      }, {
        text: "",
        sortable: false
      }]

      if (this.ruleQuickView) { // Just title when quick view is visible
        headerToDisplay = [{
          text: messages.label.TH_TITLE,
          sortable: true,
          align: "left",
          value: "title"
        }]
      } else {
        headerToDisplay = commonHeaders
        // Rule / Rule Set / Rule Collection specific
        switch (this.rulesQueryObject.category) {
          case RULE_CAT_RULE:
            if (this.displayActionsCount()) {
              headerToDisplay = headerToDisplay.concat([{
                text: messages.label.TH_ACTIONS_COUNT,
                sortable: false,
                align: "left",
                value: "actions"
              }])
            }
            headerToDisplay = headerToDisplay.concat([{
              text: messages.label.TH_CONDITIONS_COUNT,
              sortable: false,
              align: "left",
              value: "conditions"
            }])
            break
          case RULE_CAT_RULE_SET:
            headerToDisplay = headerToDisplay.concat([{
              text: messages.label.TH_RULES_COUNT,
              sortable: false,
              align: "left",
              value: "rules"
            }])
            break
          case RULE_CAT_RULE_COLLECTION:
            headerToDisplay = headerToDisplay.concat([{
              text: messages.label.TH_RULE_SET_COUNT,
              sortable: false,
              align: "left",
              value: "ruleSets"
            }])
            break
        }
        headerToDisplay = headerToDisplay.concat(dateAndActionHeaders)
      }
      return headerToDisplay
    },

    /**
     * filterRulesList - For filtering rules list with text value
     * @param {string} search
     */
    filterRulesList(search) {
      if (search) {
        search = search.toString().toLowerCase()
        const displayedKeys = [
          "title",
          "type",
          "_enabled",
          "_updated"
        ]
        this.filteredRulesList = this.rulesList.filter((obj) => {
          let filteredObj = this.$lodash.pick(obj, displayedKeys)
          return Object.keys(filteredObj).some(function (key) {
            if (filteredObj[key] !== null) {
              return filteredObj[key]
                .toString()
                .toLowerCase()
                .includes(search)
            }
          })
        })
      } else {
        this.filteredRulesList = this.rulesList
      }
    },

    /**
     * Get pagination params
     */
    getPageParams(pagination) {
      let startRange
      let endRange
      if (pagination.page === 1) {
        startRange = 1
        endRange = pagination.rowsPerPage
      } else {
        startRange = (pagination.page - 1) * pagination.rowsPerPage + 1
        endRange = startRange + pagination.rowsPerPage - 1
      }
      return startRange + "-" + endRange
    },

    /**
     * getSortParams - Construct sorting param
     *
     * @param  {object} pagination pagination object
     * @return {string}            ex: '<filedName>|desc'
     */
    getSortParams(pagination) {
      let sortParams = ""
      sortParams =
        !this.$lodash.isNull(pagination.sortBy) &&
          !this.$lodash.isEmpty(pagination.sortBy)
          ? pagination.sortBy
          : "title"
      if (pagination.descending) {
        sortParams += "|desc"
      }
      return sortParams
    },

    /**
     * initiateRulesSearch
     * @param {object} searchParams
     */
    initiateRulesSearch(searchParams) {
      this.initiatedSearch = true
      this.SET_RULE_QUICK_VIEW(false)
      this.selectedRule = {}
      this.rulesQueryObject = searchParams

      this.searchRules().then(() => {
      }).catch(() => {
      })
    },

    /**
     * searchRules - retrieves rules / rule sets / rule collection based on grouping selected
     * @return {array}
     */
    searchRules() {
      this.rulesLoading = true
      this.rulesList = []
      let queryObject = this.$lodash.cloneDeep(this.rulesQueryObject)
      // Omit 'grouping' as they are client only
      queryObject = this.$lodash.omit(queryObject, ["grouping"])
      queryObject.range = this.getPageParams(this.pagination)
      queryObject.sort = this.getSortParams(this.pagination)

      let searchPromise = {}
      switch (this.rulesQueryObject.category) {
        case RULE_CAT_RULE:
          searchPromise = this.retrieveRules(queryObject)
          break
        case RULE_CAT_RULE_SET:
          searchPromise = this.retrieveRuleSets(queryObject)
          break
        case RULE_CAT_RULE_COLLECTION:
          searchPromise = this.retrieveRuleCollections(queryObject)
          break
      }

      return searchPromise
        .then((response) => {
          let entries = []
          // NOTE: Temporary fix, as the data comes back as string sometimes
          if (this.$lodash.isString(response.data)) {
            try {
              let data = JSON.parse(response.data)
              entries = data.entries
            } catch (e) {
              console.error("Unable to parse response: " + e)
              return []
            }
          } else {
            entries = response.data.entries
          }
          this.rulesList = XVATRulesService.addClientOnlyFields(entries)
          this.filterRulesList(this.search)
          this.totalItems = response.data.entryCount
          return response
        }).catch((error) => {
          // TODO: handle error
          this.rulesList = []
          this.filteredRulesList = []
          this.totalItems = 0
          return Promise.reject(error)
        }).finally(() => {
          this.rulesLoading = false
        })
    },

    /**
     * retrieveRules - Retrieve rules list
     * @param {object} queryObject
     * @returns {Promise}
     */
    retrieveRules(queryObject) {
      return xvatRulesDataService
        .searchRule(queryObject)
        .then((response) => {
          return response
        }).catch((error) => {
          return Promise.reject(error)
        })
    },

    /**
     * retrieveRuleSets - Retrieve rule sets
     * @param {object} queryObject
     * @returns {Promise}
     */
    retrieveRuleSets(queryObject) {
      return xvatRulesDataService
        .searchRuleSet(queryObject)
        .then((response) => {
          return response
        }).catch((error) => {
          return Promise.reject(error)
        })
    },

    /**
     * retrieveRuleCollections - Retrieve rule collection
     * @param {object} queryObject
     * @returns {Promise}
     */
    retrieveRuleCollections(queryObject) {
      return xvatRulesDataService
        .searchRuleCollection(queryObject)
        .then((response) => {
          return response
        }).catch((error) => {
          return Promise.reject(error)
        })
    },

    /**
     * showDeleteDialog -
     */
    showDeleteDialog(rule) {
      this.selectedRuleToDelete = rule
      this.deleteDialog = true
    },

    /**
     * cancelDelete - close delete dialog
     */
    cancelDelete() {
      this.selectedRuleToDelete = {}
      this.deleteErrorAlert = false
      this.deleteErrorMessage = ""
      this.deleteDialog = false
    },

    /**
     * deleteRuleItem - Delete selected rule / ruleset / rule collection
     */
    deleteRuleItem() {
      this.deletingRule = true
      let id = this.selectedRuleToDelete.id
      let deletePromise = {}

      switch (this.rulesQueryObject.category) {
        case RULE_CAT_RULE:
          deletePromise = this.deleteRule(id)
          break
        case RULE_CAT_RULE_SET:
          deletePromise = this.deleteRuleSet(id)
          break
        case RULE_CAT_RULE_COLLECTION:
          deletePromise = this.deleteRuleCollection(id)
          break
      }

      deletePromise
        .then(() => {
          this.selectedRuleToDelete = {}
          this.deleteDialog = false
          // Show Snackbar
          this.snackbar.show = true
          this.snackbar.color = "success"
          this.snackbar.message = this.messages.info.DELETE_SUCCESS + this.getRuleCategoryTitle()
          // Update search result
          this.searchRules()
        }).catch((error) => {
          let response = error.response.data
          if (response.isException) {
            this.deleteErrorAlert = true
            if (response.responseCode === 412) {
              this.deleteErrorMessage = XVATRulesService.constructDeleteFailMsg(this.getRuleCategoryTitle(), this.selectedRuleToDelete.title)
            } else {
              this.deleteErrorMessage = response.description
            }
          }
        }).finally(() => {
          this.deletingRule = false
        })
    },

    /**
    * deleteRule - Delete rule
    * @param {object} queryObject
    * @returns {Promise}
    */
    deleteRule(ruleId) {
      return xvatRulesDataService
        .deleteRule(ruleId)
        .then((response) => {
          return response
        }).catch((error) => {
          return Promise.reject(error)
        })
    },

    /**
     * deleteRuleSet - Delete rule set
     * @param {object} queryObject
     * @returns {Promise}
     */
    deleteRuleSet(ruleSetId) {
      return xvatRulesDataService
        .deleteRuleSet(ruleSetId)
        .then((response) => {
          return response
        }).catch((error) => {
          return Promise.reject(error)
        })
    },

    /**
     * deleteRuleCollection - Delete rule collection
     * @param {object} queryObject
     * @returns {Promise}
     */
    deleteRuleCollection(ruleCollectionId) {
      return xvatRulesDataService
        .deleteRuleCollection(ruleCollectionId)
        .then((response) => {
          return response
        }).catch((error) => {
          return Promise.reject(error)
        })
    },

    /**
     * displayConditionsCount  - identify if conditions count column needs to be displayed
     * @returns {boolean}
     */
    displayConditionsCount() {
      const category = this.rulesQueryObject.category
      let display = false
      if (!this.ruleQuickView && category === RULE_CAT_RULE) {
        display = true
      }
      return display
    },

    /**
     * displayActionsCount  - identify if actions count column needs to be displayed
     * @returns {boolean}
     */
    displayActionsCount() {
      const category = this.rulesQueryObject.category
      let display = false
      if (!this.ruleQuickView &&
        category === RULE_CAT_RULE &&
        (this.$lodash.isUndefined(this.rulesQueryObject.byType) ||
          this.rulesQueryObject.byType === RULE_TYPE_TRANSFORMATION)) {
        display = true
      }
      return display
    },

    /**
    * displayRulesCount  - identifying conditions for displaying the rulesCount column
    * @returns {boolean}
    */
    displayRulesCount() {
      const category = this.rulesQueryObject.category
      let display = false
      if (!this.ruleQuickView && (category === RULE_CAT_RULE_SET)) {
        display = true
      }
      return display
    },

    /**
     * displayRuleSetsCount  - identifying conditions for displaying the ruleSetsCount column
     * @returns {boolean}
     */
    displayRuleSetsCount() {
      const category = this.rulesQueryObject.category
      let display = false
      if (!this.ruleQuickView && category === RULE_CAT_RULE_COLLECTION) {
        display = true
      }
      return display
    },

    /**
     * getRuleConditionsCount - return count of conditions exists in a rule
     * @param {array} conditionsArray
     * @returns {number}
     */
    getRuleConditionsCount(conditionsArray) {
      if (!this.$lodash.isUndefined(conditionsArray) && !this.$lodash.isNull(conditionsArray)) {
        return conditionsArray.length
      } else {
        return 0
      }
    },

    /**
     * getRuleActionsCount - return count of actions exists in a rule
     * @param {array} actionsArray
     * @returns {number}
     */
    getRuleActionsCount(actionsArray) {
      if (!this.$lodash.isUndefined(actionsArray) && !this.$lodash.isNull(actionsArray)) {
        return actionsArray.length
      } else {
        return 0
      }
    },

    /**
     *  getRuleSetsCount - return count of rule sets exists in a rule collection
     * @param {array} itemsArray
     */
    getRuleSetsCount(itemsArray) {
      if (!this.$lodash.isUndefined(itemsArray)) {
        return itemsArray.length
      } else {
        return 0
      }
    },

    /**
     *  getRulesCount - return count of rules exists in a rule set or in a rule collections
     * @param {array} itemsArray
     */
    getRulesCount(itemsArray) {
      if (!this.$lodash.isUndefined(itemsArray)) {
        return itemsArray.length
      } else {
        return 0
      }
    },

    /**
     * showQuickView - Show selected rule details
     * @param {object} selectedRule
     */
    showQuickView(selectedRule) {
      this.selectedRule = selectedRule
      this.SET_RULE_QUICK_VIEW(true)
      this.dispatchShowQuickViewEvent(selectedRule)
    },

    /**
     * dispatchShowQuickViewEvent
     * @param {object} rule
     */
    dispatchShowQuickViewEvent(rule) {
      // NOTE: param 'rule' can be a rule / rule set / rulecollection object
      switch (this.rulesQueryObject.category) {
        case RULE_CAT_RULE:
          XVATRulesService.$emit("event:showRuleQuickView", rule)
          break
        case RULE_CAT_RULE_SET:
          XVATRulesService.$emit("event:showRuleSetQuickView", rule)
          break
        case RULE_CAT_RULE_COLLECTION:
          XVATRulesService.$emit("event:showRuleCollectionQuickView", rule)
          break
      }
    },

    /**
     * getCopyLabelInfo - for displayig Copy Label for rule / rule set & rule collection
     */
    getCopyLabelInfo() {
      let copyLabel = ""
      switch (this.rulesQueryObject.category) {
        case RULE_CAT_RULE:
          copyLabel = this.messages.label.COPY_RULE
          break
        case RULE_CAT_RULE_SET:
          copyLabel = this.messages.label.COPY_RULE_SET
          break
        case RULE_CAT_RULE_COLLECTION:
          copyLabel = this.messages.label.COPY_RULE_COLLECTION
          break
      }
      return copyLabel
    },

    /**
     * getOverrideLabelInfo - for displayig Override Label for rule / rule set & rule collection
     */
    getOverrideLabelInfo() {
      let overrideLabel = ""
      switch (this.rulesQueryObject.category) {
        case RULE_CAT_RULE:
          overrideLabel = this.messages.label.OVERRIDE_RULE
          break
        case RULE_CAT_RULE_SET:
          overrideLabel = this.messages.label.OVERRIDE_RULE_SET
          break
        case RULE_CAT_RULE_COLLECTION:
          overrideLabel = this.messages.label.OVERRIDE_RULE_COLLECTION
          break
      }
      return overrideLabel
    },

    /**
     * hideQuickView
     */
    hideQuickView() {
      this.selectedRule = {}
      this.SET_RULE_QUICK_VIEW(false)
    },

    /**
     * refreshSearchResults - Update search result and re-populate the quick view
     */
    refreshSearchResults() {
      if (this.rulesList.length === 0) return

      this.searchRules().then(() => {
        this.selectedRule = this.$lodash.find(this.filteredRulesList, (item) => {
          return item.id === this.selectedRule.id
        })
        if (!this.$lodash.isUndefined(this.selectedRule)) {
          this.dispatchShowQuickViewEvent(this.selectedRule)
        } else {
          this.hideQuickView()
        }
      }).catch(() => {
        if (this.filteredRulesList.length === 0) {
          this.hideQuickView()
        }
      })
    },

    /**
     * stopProp - Do nothing, just to stop event propogation
     */
    stopProp() { },

    /**
     * goToEditView - Navigate to Edit view
     */
    goToEditView(item) {
      const category = this.rulesQueryObject.category
      let id = item.id
      switch (category) {
        case RULE_CAT_RULE:
          this.$router.push({ name: "XVATManageRule", params: { id: id } })
          break
        case RULE_CAT_RULE_SET:
          this.$router.push({ name: "XVATManageRuleSet", params: { id: id } })
          break
        case RULE_CAT_RULE_COLLECTION:
          this.$router.push({ name: "XVATManageRuleCollection", params: { id: id } })
          break
      }
    },

    /**
     * getRuleCategoryTitle - returns rule / ruleset / rule collection based on
     * selected grouping
     * @returns {string}
     */
    getRuleCategoryTitle() {
      const category = this.rulesQueryObject.category
      let categoryTitle = ""
      switch (category) {
        case RULE_CAT_RULE:
          categoryTitle = this.messages.label.RULE
          break
        case RULE_CAT_RULE_SET:
          categoryTitle = this.messages.label.RULE_SET
          break
        case RULE_CAT_RULE_COLLECTION:
          categoryTitle = this.messages.label.RULE_COLLECTION
          break
      }
      return categoryTitle
    },

    /**
     * showTestRuleModal
     * @param {object} ruleObj - Can be rule / ruleset / rule collection
     */
    showTestRuleModal(ruleObj) {
      this.ruleObjectToTest = ruleObj
      this.ruleTestDialog = true
    },

    /**
     * showCopyRuleModal
     * @param {object} ruleObj - Can be rule / ruleset / rule collection
     */
    showCopyRuleModal(ruleObj) {
      this.ruleObjectToCopy = ruleObj
      this.ruleCopyDialog = true
    },

    /**
     * showOverrideRuleModal
     * @param {object} ruleObj - Can be rule / ruleset / rule collection
     */
    showOverrideRuleModal(ruleObj) {
      this.ruleObjectToOverride = ruleObj
      this.ruleOverrideDialog = true
    }
  },
  created() {
    /**
     * Non reactive properties
     */
    this.messages = messages
    /**
     * Events
     */
    XVATRulesService.$on("event:searchMetadataRules", this.initiateRulesSearch)
    XVATRulesService.$on("event:refreshRulesList", this.refreshSearchResults)
    XVATRulesService.$on("event:hideRuleQuickView", this.hideQuickView)
    XVATRulesService.$on("event:hideRuleSetQuickView", this.hideQuickView)
    XVATRulesService.$on("event:hideRuleCollectionQuickView", this.hideQuickView)
    AppService.$on("event:mpxAccountChanged", this.reset)
  },
  beforeDestroy() {
    XVATRulesService.$off("event:searchMetadataRules", this.initiateRulesSearch)
    XVATRulesService.$off("event:refreshRulesList", this.refreshSearchResults)
    XVATRulesService.$off("event:hideRuleQuickView", this.hideQuickView)
    XVATRulesService.$off("event:hideRuleSetQuickView", this.hideQuickView)
    XVATRulesService.$off("event:hideRuleCollectionQuickView", this.hideQuickView)
    AppService.$off("event:mpxAccountChanged", this.reset)
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/XVAT/XVATRulesSearchResult.vue